import React from "react";
import "./Services.css";

import { BiChevronDownCircle, BiLayout } from "react-icons/bi";

const Services = () => {
//   const [toggleState, setToggleState] = useState(0);

//   const toggleTab = (index) => {
//     // Se clicar no mesmo item que já está aberto, fecha
//     if (toggleState === index) {
//       setToggleState(0);
//     } else {
//       // Caso contrário, abre o novo item
//       setToggleState(index);
//     }
//   };

  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What I offer</span>

      <div className="services__container container grid">
        {/* Web Development - Content 1 */}
        <div
          className="services__content"
        >
          <div className="services__header">
        
              <BiLayout className="services__icon" />
              <h3 className="services__title">Web Development</h3>
            

            <div>
              {/* <span className="services__button" onClick={() => toggleTab(1)}>
                        {toggleState === 1 ? 'Show Less' : 'View More'}
                        <BiRightArrowAlt className={`services__button-icon ${toggleState === 1 ? 'rotated' : ''}`}/>
                    </span> */}
            </div>
          </div>

          {/* Conteúdo expandido abaixo do título */}
          <div>
            <p className="services__expanded-description">
              I help businesses and entrepreneurs build high-quality web and
              mobile interfaces using React, Next.js, WordPress, and React
              Native — always focused on performance, usability, and clean
              design.
            </p>

            <ul className="services__expanded-services grid">
              <li className="services__expanded-service">
                <BiChevronDownCircle className="services__expanded-icon" />
                <p className="services__expanded-info">
                  Development of fast and SEO-optimized websites using React and
                  Next.js.
                </p>
              </li>
              <li className="services__expanded-service">
                <BiChevronDownCircle className="services__expanded-icon" />
                <p className="services__expanded-info">
                  Creation of responsive and visually engaging user interfaces
                  with Tailwind CSS and Material UI.
                </p>
              </li>
              <li className="services__expanded-service">
                <BiChevronDownCircle className="services__expanded-icon" />
                <p className="services__expanded-info">
                  Integration of APIs (REST / GraphQL) and dynamic data handling
                  for scalable web applications.
                </p>
              </li>
              <li className="services__expanded-service">
                <BiChevronDownCircle className="services__expanded-icon" />
                <p className="services__expanded-info">
                  Development of custom WordPress themes and headless
                  integrations with modern frontend frameworks.
                </p>
              </li>
              <li className="services__expanded-service">
                <BiChevronDownCircle className="services__expanded-icon" />
                <p className="services__expanded-info">
                  Mobile app development with React Native (intermediate level)
                  focused on cross-platform UI and smooth user experience.
                </p>
              </li>
              <li className="services__expanded-service">
                <BiChevronDownCircle className="services__expanded-icon" />
                <p className="services__expanded-info">
                  Performance optimization and Core Web Vitals improvement for
                  better usability and conversions.
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Você pode adicionar os outros serviços aqui seguindo o mesmo padrão */}
      </div>
    </section>
  );
};

export default Services;
